var map = {
	"./Cards.css": 5563,
	"./cards": 1425,
	"./cards.js": 1425,
	"./data": 7818,
	"./data-img/01.jpg": 7076,
	"./data-img/02.jpg": 472,
	"./data-img/03.jpg": 5601,
	"./data.js": 7818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1948;